// src/pages/backoffice/MenuFormModal.jsx
import React, { useState } from "react";
import Swal from "sweetalert2";
import { getApiClient } from "../../libs/axiosInstance";

const axios = getApiClient();

export default function MenuFormModal({ initial, onClose, onSaved }) {
  const [name, setName] = useState(initial.name || "");
  const [description, setDescription] = useState(initial.description || "");
  const [isActive, setIsActive] = useState(initial.isActive ?? true);
  const isEdit = Boolean(initial._id);

  async function handleSave() {
    if (!name.trim()) {
      Swal.fire("Name required", "", "warning");
      return;
    }

    try {
      if (isEdit) {
        await axios.put(`/api/myshop/menus/${initial._id}`, {
          name,
          description,
          isActive,
        });
      } else {
        await axios.post(`/api/myshop/menus`, {
          name,
          description,
          isActive,
        });
      }

      Swal.fire("Saved", "Menu saved successfully", "success");
      onSaved?.();
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Save failed", "error");
    }
  }

  return (
    <div className="modal d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title">
              {isEdit ? "Edit Menu" : "New Menu"}
            </h6>
            <button className="btn-close" onClick={onClose} />
          </div>

          <div className="modal-body" style={{ fontSize: "13px" }}>
            <div className="mb-2">
              <label className="form-label">Name</label>
              <input
                className="form-control form-control-sm"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="mb-2">
              <label className="form-label">Description</label>
              <textarea
                className="form-control form-control-sm"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
              />
              <label className="form-check-label">Active</label>
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary btn-sm" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-primary btn-sm" onClick={handleSave}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
